let currentDashboard;

export const setDashboard = (value) => {
  currentDashboard = value;
};

export const getDashboard = () => {
  return currentDashboard;
};
